// extracted by mini-css-extract-plugin
module.exports = {"rank":"ResultRow-module--rank--gVBYO","name":"ResultRow-module--name--2j-gA","score":"ResultRow-module--score--2XyZP","members":"ResultRow-module--members--5DyXV"};